import React from 'react';
import { Wallet, Check, Lock } from 'lucide-react';
import { colors, spacing, typography } from '../../../../tokens';

interface StakingStepsProps {
  currentStep: number;
}

export const StakingSteps: React.FC<StakingStepsProps> = ({ currentStep }) => {
  const steps = [
    { number: 1, label: 'Connect Wallet', icon: Wallet },
    { number: 2, label: 'Switch Network', icon: Check },
    { number: 3, label: 'Sign Message', icon: Check },
    { number: 4, label: 'Stake Tokens', icon: Lock },
  ];

  return (
    <div>
      <style>{`
        @media (max-width: 500px) {
          .staking-steps-container {
            flex-direction: column !important;
            align-items: flex-start !important;
          }
          .staking-steps-separator {
            width: 2px !important;
            height: 20px !important;
            margin-left: 19px !important;
          }
        }
      `}</style>
      <div className="staking-steps-container" style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: spacing['2xl'],
        gap: spacing.md,
      }}>
      {steps.map((step, index) => {
        const isCompleted = currentStep > step.number;
        const isActive = currentStep === step.number;
        const Icon = step.icon;

        return (
          <React.Fragment key={step.number}>
            <div style={{
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              gap: spacing.sm,
            }}>
              <div style={{
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: isCompleted
                  ? colors.semantic.success
                  : isActive
                    ? colors.brand.purple.base
                    : colors.neutral.gray[100],
                color: isCompleted || isActive
                  ? colors.neutral.white
                  : colors.text.muted.default,
                fontWeight: typography.fontWeight.bold,
              }}>
                {isCompleted ? (
                  <Check size={20} />
                ) : (
                  <Icon size={20} />
                )}
              </div>
              <span style={{
                fontSize: typography.fontSize.sm,
                fontWeight: isActive ? typography.fontWeight.semibold : typography.fontWeight.medium,
                color: isActive
                  ? colors.text.primary.default
                  : isCompleted
                    ? colors.text.secondary.default
                    : colors.text.muted.default,
              }}>
                {step.label}
              </span>
            </div>
            {index < steps.length - 1 && (
              <div className="staking-steps-separator" style={{
                height: '2px',
                flex: '0 0 auto',
                width: '40px',
                backgroundColor: currentStep > step.number
                  ? colors.semantic.success
                  : colors.neutral.gray[100],
              }} />
            )}
          </React.Fragment>
        );
      })}
      </div>
    </div>
  );
};
